import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DataStateChangeEventArgs, FilterSettingsModel, GridComponent, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { ToastrService } from 'ngx-toastr';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';
import { IsViewEditpayrate, payrateGridBO, EmployeePayrateBO, functionpermission } from '../employee.model';
import { EmployeeService } from '../employee.service';
import { EmployeepayrateService } from '../employeepayrate.service';

@Component({
  selector: 'app-pay-rates-list',
  templateUrl: './pay-rates-list.component.html',
  styleUrls: ['./pay-rates-list.component.scss']
})
export class PayRatesListComponent implements OnInit {
  private onDestroy$: Subject<void> = new Subject<void>();
  @Input() payratevalueChange: string;
  @Output() IsViewEditpayrate = new EventEmitter<IsViewEditpayrate>();
  public data: Observable<DataStateChangeEventArgs>;
  @ViewChild('grid') public grid:GridComponent
  tempayrate: EmployeePayrateBO[];
  payRateBo=new payrateGridBO;
  val:any;
  EmpId: string;
  filterOptions: FilterSettingsModel;
  initialPage: object;
  public filterSettings: FilterSettingsModel;
  public formatOptions1: object;
  public formatOptions: object;
  public wrapSettings: TextWrapSettingsModel;
  
  constructor(public global:GlobalComponent, private employeePayrateRequest:EmployeepayrateService,private employeeService:EmployeeService,private toastrService:ToastrService) {
    this.data=this.employeePayrateRequest
    this.global.checkforlogout();
     
  }
  fp:functionpermission=new functionpermission();

  ngOnInit(): void {

    this.formatOptions = { type: 'date', format: 'MM/dd/yyyy' };
    this.wrapSettings = { wrapMode: 'Content' };
    this.filterOptions = { type: 'Excel' };
    this.filterSettings = { type: 'Menu' };
    this.formatOptions1 = { type: 'date', format: 'MM/dd/yyyy HH:mm:ss' };
    this.initialPage = { pageSizes: ['10', '20', '50', '100', '250'], pageSize: 10 };
    this.getpayrateList();
    this.getpermission()

  }

  getpayrateList(){
    this.payRateBo.employeeID=this.payratevalueChange
    this.payRateBo.agencyId=this.global.globalAgencyId
    this.employeePayrateRequest.executepayrate(this.payRateBo)
    this.data.pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {
    })
  }

  getpermission() {
    if (this.global.LoginUserType.toUpperCase() != 'ONBOARD' && (this.global.globalAgencyId!=null&&this.global.globalAgencyId!=undefined&&this.global.globalAgencyId!='')) {
    let params = new URLSearchParams();
    params.append("pagecode", "employee");
    params.append("roleId", this.global.roleId);
    params.append("agencyId", this.global.globalAgencyId)
    this.employeeService.getpermission(params).pipe(takeUntil(this.onDestroy$)).subscribe((data: any) => {

      if (data != null) {
        this.fp = data;

      }
      else {
        this.fp = new functionpermission();
      }
    },
      (err: HttpErrorResponse) => {
        this.fp = new functionpermission();
      })
  }
}

  editPayrate(type, edit) {
    if(this.tempayrate){
        this.val = JSON.parse(JSON.stringify(this.tempayrate))
    }
        if (type == 'new') {
          this.IsViewEditpayrate.emit({ isView: false, isEdit: true, isEditPayorrate: false, employeeId: this.payratevalueChange,updatedata: edit, payrateId: "00000000-0000-0000-0000-000000000000", payrate: this.val, payratetype: 'payrate' })
        }       
        else if (type == 'edit') {
          this.IsViewEditpayrate.emit({
            isView: false, isEdit: true, isEditPayorrate: true, employeeId: this.payratevalueChange, payrateId: edit.id, payrate: this.val, payratetype: 'payrate',updatedata: edit
          })
        }
        else {
          this.IsViewEditpayrate.emit({ isView: false, isEdit: true, isEditPayorrate: true, employeeId: this.payratevalueChange,updatedata: edit, payrateId: edit.id, payrate: this.val, payratetype: 'delete' })
        }       
      }

      setDeleteId(value) {     
        this.EmpId = value;
        
      }
      Delete(){
  
        let param = new URLSearchParams()
        param.append("id", this.EmpId)
        this.employeeService.deletepayrate(param).subscribe((_data: any) => {
          this.toastrService.success("Pay rates has been deleted successfully", " Record deleted");
          document.getElementById("openDelete").click();
           this.getpayrateList();
        },
          err => {
            this.toastrService.error(err.error);
          })
         
      }

      documentType:string=""
      public onActionComplete(G) {
        this.payRateBo.currentpageno =
          this.grid.pagerModule.pagerObj.currentPage;
        this.payRateBo.pageitem = this.grid.pagerModule.pagerObj.pageSize;
        if (G.name == "actionBegin" && G.requestType == "filterbeforeopen") {
          this.payRateBo.type = G.columnType;
        }
      }
    
      public dataStateChange(state): void {
        this.documentType = state.action.requestType.toString();
        if (this.documentType != "filterchoicerequest") {
          if ((state.sorted || []).length) {
            this.payRateBo.orderColumn = state.sorted[0].name;
            this.payRateBo.orderType =
              state.sorted[0].direction === "descending" ? "DESC" : "ASC";
          }
        }
        if (
          this.documentType == "filtering" &&
          state.action.action != "clearFilter"
        ) {
          this.payRateBo.field = state.action.currentFilterObject.field;
          this.payRateBo.matchCase =
            state.action.currentFilterObject.matchCase;
          this.payRateBo.operator = state.action.currentFilterObject.operator;
          this.payRateBo.value = state.action.currentFilterObject.value;
          this.payRateBo.orderColumn =
            state.action.currentFilterObject.field;
            if(this.payRateBo.type == 'number'){
              this.payRateBo.value = (this.payRateBo.value != null && this.payRateBo.value != undefined)
              ? this.payRateBo.value.toString() : null;
            }
          if(this.payRateBo.type == "date"){
              var isValid = !isNaN(Date.parse(this.payRateBo.value)) ? new Date(this.payRateBo.value).toString() : null;
            }
          if(this.payRateBo.field == 'rate'){
            this.payRateBo.type = 'decimal';
          }
        }
        if ((this.documentType == "filtering" && state.action.action == "clearFilter")
          || ((this.payRateBo.type != 'string')
          && (this.payRateBo.value==null || this.payRateBo.value == undefined || this.payRateBo.value==''))) {
          this.payRateBo.field = "clientName";
          this.payRateBo.matchCase = false;
          this.payRateBo.operator = "startswith";
          this.payRateBo.value = "";
          this.payRateBo.orderColumn = "clientName";
          this.payRateBo.type="string";
        }
        this.getpayrateList();
      }


}

